var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{attrs:{"day":_vm.day,"color":"red"}},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"body__na",attrs:{"data-autotests-id":("calendar-day:" + _vm.day + ":sold-out")}},[_vm._v("N/A")])])])}
var staticRenderFns = []

export { render, staticRenderFns }